import { Pagination, Stack } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';

import { TextInput } from '@shared/inputs/TextInput';
import { UnassignedAgentsWrapper } from '@styles/Admin-tools/TeamManagerStyle';

import { NTeamManager } from '../interfaces';
import { UsersList } from './UsersList';

interface IUnassignedAgentsProps {
  data?: NTeamManager.User[];
  agents: NTeamManager.User[];

  setAgents(agents: NTeamManager.User[]): void;
}

export const UnassignedAgents = ({ data = [], agents, setAgents }: IUnassignedAgentsProps) => {
  const pageSize = 25;
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const processSearch = (input: NTeamManager.User[], query: string) => {
    return input.filter((item) => {
      return item.userName.split(' ').some((word) => word.toLowerCase().startsWith(query.toLowerCase()));
    });
  };

  const filtered = processSearch(data, searchQuery);

  const processFilteredPagination = useCallback(() => {
    const skip = pageSize * (currentPage - 1);
    const take = skip + pageSize;
    setAgents(filtered.slice(skip, take));
  }, [data, searchQuery, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
    processFilteredPagination();
  }, [searchQuery]);

  useEffect(() => {
    processFilteredPagination();
  }, [data, currentPage]);

  const count = Math.ceil((searchQuery ? filtered.length : data.length) / pageSize);

  return useMemo(
    () => (
      <UnassignedAgentsWrapper>
        <TextInput
          sx={{ mb: 2 }}
          label="Search Agents"
          value={searchQuery}
          onChange={({ target: { value } }) => setSearchQuery(value)}
        />

        <UsersList showScroll droppableId="unassigned" height="calc(100% - 195px)" label="Unassigned Agents" data={agents} />

        <Stack spacing={2} sx={{ mt: 2 }}>
          <Pagination
            size="small"
            count={count}
            shape="rounded"
            page={currentPage}
            onChange={(event, page) => setCurrentPage(page)}
          />
        </Stack>
      </UnassignedAgentsWrapper>
    ),
    [agents, currentPage, searchQuery],
  );
};
